import { createElement, memo, useCallback, useMemo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Button from '@hfe/max-button';
import Image from '@hfe/max-image';
import { PrizeStatusDesc } from '../../types';
import './index.scss';
import { BID_MAP, BID_TYPE } from '../../constants';
import Sensor from '@max/mbc-sensor';
import LinearGradient from '@hfe/max-linear-gradient';
import { getPrizeModalInfo } from '@/utils';
const RewardCouponPackage = ({ prize, onGoToUse, lxReport }) => {
    const handlePress = useCallback(() => {
        lxReport(BID_MAP.PACKAGE_MODULE_BUTTON_MC, BID_TYPE.MC);
        onGoToUse(prize);
    }, [prize, onGoToUse]);
    const buttonText = PrizeStatusDesc[prize.prizeStatus];
    const prizeModalInfo = useMemo(() => getPrizeModalInfo((prize === null || prize === void 0 ? void 0 : prize.userSubPrizeInfoList) || [], true), [prize === null || prize === void 0 ? void 0 : prize.userSubPrizeInfoList]);
    // console.log('prizeModalInfo', prizeModalInfo);
    const { title, desc } = prizeModalInfo || {};
    return <Sensor className="package-card" once onAppear={() => {
        lxReport(BID_MAP.PACKAGE_MODULE_MV, BID_TYPE.MV);
    }}>
      
      <View className="discount-card">
        <Image className="discount-card-image" source={{
        uri: 'https://p0.meituan.net/ingee/e9f771e304646306b1000fd2590046dd10687.png'
    }}/>
      </View>

      
      <View className="package-content">
        <Text className="package-title" numberOfLines={1}>周周半价{title}</Text>
        <Text className="package-description" numberOfLines={2}>{desc}</Text>
      </View>

      
      <LinearGradient colors={['#FF9233', '#FF5500']} className="go-use-btn" start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 0
    }}>
        <Button 
    // className="go-use-btn"
    onPress={handlePress}>
          <Text className="go-use-btn-text">{buttonText}</Text>

        </Button>
      </LinearGradient>
    </Sensor>;
};
export default memo(RewardCouponPackage);
